module.exports = __webpack_public_path__ + "img/basic-residence-mini.9af25fe6.png";